import PropTypes from 'prop-types';

export default {
  errorCodes: PropTypes.arrayOf(PropTypes.string),
  statePath: PropTypes.string,
  runAllHandlers: PropTypes.bool,
};
